export const ro = {
  upload: "Încărcare",
  cancel: "Anulare",
  close: "Închide",
  uploading: "Încărcare...",
  uploaded: "Încărcat",
  fetching: "Obținere imagine de la $1$...",
  poweredBy: "Susținut de $1$",
  needHelp: "Ai nevoie de ajutor?",

  units: {
    px: "px",
    "%": "%",
    deg: "°",
  },

  errors: {
    response_not_ok: "S-a produs o eroare in timpul obținerii acestui fișier",
    unable_to_search: "S-a produs o eroare in timpul căutării",
    invalid_service_url: "Acesta nu este un URL de $1$",
    invalid_url: "Acest URL nu este valid",
    upload_aborted: "Încărcare a fost anulată",
    upload_error: "S-a produs o eroare in timpul încărcarii acestui fișier",
    file_type_not_allowed: "Acest tip de fișier nu este permis.",
    file_too_large: "Fișierul trebuie să fie mai mic de $1$",
  },

  help: {
    loading: "Se obține ajutor...",
    close: "Închidere ajutor",
  },

  services: {
    default: {
      heading: "Selectează o imagine",
    },
    local: {
      title: "Alege un fișier",
      button: "Selectează un fișier",
      or: "ori",
      drop: "Plasați fișierele aici",
    },
    camera: {
      title: "Cameră",
      button: "Capturează o imagine",
      switch: "Schimbă camera",
      waiting: "Se așteaptă permisiunea...",
      unableToRead:
        "Nu putem să citim semnalul video al camerei. Acest lucru se poate întâmpla pentru că nu ați acordat permisiunea necesară sau pentru că dispozitivul dvs. nu acceptă accesul camerei.",
    },
    microlink: {
      button: "Importă de pe $1$",
      label: "$1$ $2$ URL",
      placeholder: "Tastează $1$ $2$ URL",
      type: "trimite",
    },
    url: {
      title: "URL direct",
      label: "URL imagine",
      placeholder: "Tastează URL-ul imaginii",
    },
    instagram: {
      title: "Instagram",
    },
    facebook: {
      title: "Facebook",
    },
    flickr: {
      title: "Flickr",
      type: "fotografie",
    },
    ninegag: {
      title: "9GAG",
      type: "fotografie",
    },
    deviantart: {
      title: "DeviantArt",
    },
    artstation: {
      title: "ArtStation",
    },
    twitter: {
      title: "Twitter",
      type: "tweet imagine",
    },
    pinterest: {
      title: "Pinterest",
      type: "pin",
    },
    flipboard: {
      title: "Flipboard",
      type: "articol",
    },
    fotki: {
      title: "Fotki",
      type: "fotografie",
    },
    linkedin: {
      title: "LinkedIn",
    },
    reddit: {
      title: "Reddit",
    },
    tumblr: {
      title: "Tumblr",
    },
    weheartit: {
      title: "We Heart It",
    },
    screenshot: {
      title: "Captură de ecran",
      button: "Capturează ecran",
      label: "URL pagină web",
      placeholder: "Tastează URL-ul imaginii",
      loading: "Se capturează ecranul...",
    },
    search: {
      button: "Caută pe $1$",
      label: "Găsește o imagine",
      placeholder: "Caută ceva",
      imagesPoweredBy: "Imagini provenite de la $1$",
    },
    giphy: {
      title: "GIPHY",
    },
    unsplash: {
      title: "Unsplash",
    },
    pixabay: {
      title: "Pixabay",
    },
    pexels: {
      title: "Pexels",
    },
  },

  effects: {
    preview: {
      title: "Previzualizare",
    },
    filters: {
      title: "Filtre",
    },
    crop: {
      title: "Decupare",
      aspectRatios: {
        free: "Liber",
        square: "Pătrat",
      },
    },
    rotate: {
      title: "Rotire",
    },
    flip: {
      title: "Oglindire",
      buttons: {
        horizontal: "Orizontal",
        vertical: "Vertical",
      },
    },
    sharpen: {
      title: "Accentuare",
    },
    blur: {
      title: "Estompare",
    },
    brightness: {
      title: "Luminozitate",
    },
    contrast: {
      title: "Contrast",
    },
    grayscale: {
      title: "Scară tonurilor de gri",
    },
    "hue-rotate": {
      title: "Rotire tonuri",
    },
    invert: {
      title: "Inversare",
    },
    saturate: {
      title: "Saturare",
    },
    sepia: {
      title: "Sepia",
    },
  },
};
